exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-description {\n  font-size: 12px;\n  text-align: left;\n  color: #9c9c9c;\n  margin-left: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/contact/contact.component.scss
// module id = ../../../../../src/app/pages/contact/contact.component.scss
// module chunks = main